import type { PageComponentProps } from '@/features/a-dynamic-page/components/page-component-switch';
import type { ActivitySpotSwiperV1Attributes } from '@/features/activity-spot-swiper-v1/activity-spot-swiper-v1-type';

import React from 'react';

import dynamic from 'next/dynamic';

import { ContentBoxSwiperDesktop } from '@/core/features';

const SpotResultHorizontalDesktop = dynamic(
    () =>
        import(
            /* webpackChunkName: "SpotResultHorizontalDesktop" */ '@/features/spot-results/spot-result-desktop/spot-result-horizontal-desktop'
        ),
);

type ActivitySpotSwiperV1Props = PageComponentProps<ActivitySpotSwiperV1Attributes>;

export default function ActivitySpotSwiperV1Desktop({
    attributes: { spotName, tiles, title },
    componentId,
}: ActivitySpotSwiperV1Props) {
    // TODO: make ContentBoxSwiper work
    return (
        <div className={'flex-column gap-15'}>
            <h2 className={'font-size-18 bold'}>{title}</h2>
            {tiles.length < 3 ? (
                <div className={'flex-row gap-10'}>
                    {tiles.map((tile, index) => (
                        <div
                            key={`${tile.id}-${index}`}
                            style={{ width: `calc(${100 / tiles.length}% - 5px)` }}
                        >
                            <SpotResultHorizontalDesktop
                                activity={tile.activity}
                                activitySpotName={tile.activitySpotName}
                                badges={[]}
                                calendar={tile.calendar}
                                hint={tile.hint}
                                id={tile.id}
                                images={tile.images}
                                keyFacts={tile.keyFacts}
                                linkUrl={tile.linkUrl}
                                spotName={spotName}
                                spotScore={tile.spotScore}
                                subtitle={tile.subtitle}
                                title={tile.title}
                                wishlistButton={tile.wishlistButton}
                            />
                        </div>
                    ))}
                </div>
            ) : (
                <ContentBoxSwiperDesktop
                    componentId={componentId}
                    slidesPerView={3}
                >
                    {tiles.map((tile, index) => (
                        <SpotResultHorizontalDesktop
                            activity={tile.activity}
                            activitySpotName={tile.activitySpotName}
                            badges={[]}
                            calendar={tile.calendar}
                            hint={tile.hint}
                            id={tile.id}
                            images={tile.images}
                            key={`${tile.id}-${index}`}
                            keyFacts={tile.keyFacts}
                            linkUrl={tile.linkUrl}
                            spotName={spotName}
                            spotScore={tile.spotScore}
                            subtitle={tile.subtitle}
                            title={tile.title}
                            wishlistButton={tile.wishlistButton}
                        />
                    ))}
                </ContentBoxSwiperDesktop>
            )}
        </div>
    );
}
